const initialLoadingState = {
    loading: false,
};

const reducerLoader = (state = initialLoadingState, action) => {
    const { type } = action;
    const isRequest = type.endsWith('_REQUEST');
    const isSuccessOrFailure = type.endsWith('_SUCCESS') || type.endsWith('_FAILURE');

    if (isRequest) {
        return { loading: true };
    }

    if (isSuccessOrFailure) {
        return { loading: false };
    }


    return state;
}

export default reducerLoader;
